var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 622,
    height: 450.184,
    viewBox: "0 0 622 450.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3278",
    "data-name": "Group 3278",
    transform: "translate(-248.489 -105.506)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 383.37,
    height: 381.542,
    transform: "translate(385.502 105.506)",
    fill: "#9c050c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 108.212,
    height: 303.495,
    transform: "translate(429.827 202.964)",
    fill: "#c10009"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 141.142,
    height: 365.833,
    transform: "translate(588.003 131.389)",
    fill: "#c10009"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    x2: 383.37,
    transform: "translate(385.502 183.952)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3276",
    "data-name": "Group 3276",
    transform: "translate(490.942 105.506)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    y2: 384.618,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    y2: 384.618,
    transform: "translate(172.489)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x2: 383.37,
    transform: "translate(385.502 340.782)",
    fill: "none",
    stroke: "#545172",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M730.488,439.68a22.243,22.243,0,0,0-20.2-31.628c-.5,0-.986.042-1.475.074A40.639,40.639,0,0,0,631.7,392.31a38.213,38.213,0,0,0-49.292,47.37Z",
    transform: "translate(107.227 85.212)",
    fill: "#3d5539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M616.036,236.13s-39.956,27.44-56.594,74.65-4.063,114.912-4.063,114.912,41.087-38.025,54.507-73.253S611.564,261.852,616.036,236.13Z",
    transform: "translate(97.59 42.164)",
    fill: "#7ba859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M557.339,310.78c20.56-43.5,56.594-74.65,56.594-74.65S573.977,263.57,557.339,310.78Z",
    transform: "translate(99.694 42.164)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M567.879,386.942s6.754-85.821,31.559-133.837",
    transform: "translate(103.096 47.643)",
    fill: "none",
    stroke: "#3d5539",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M689.318,258.739S623.406,285.6,593.454,358.85,569.4,447.76,569.4,447.76s62.323-48.09,85.809-86.673S680.93,281.648,689.318,258.739Z",
    transform: "translate(103.434 49.462)",
    fill: "#3d5539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M580.678,417.854S618.97,322.44,663.157,281.06",
    transform: "translate(107.227 56.667)",
    fill: "none",
    stroke: "#7ba859",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M745.637,288.675s-47.531-9.3-102.889,50.708-62.069,112.912-62.069,112.912,49.208-17.3,93.942-68.654S712.085,313.839,745.637,288.675Z",
    transform: "translate(107.227 58.957)",
    fill: "#7ba859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M582.863,436.1s78.981-112.487,127.69-136.02",
    transform: "translate(107.932 62.807)",
    fill: "none",
    stroke: "#3d5539",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M395.28,240.887s43.786,20.79,67.667,64.782S485.1,418.5,485.1,418.5s-46.573-31.063-65.385-63.732S403.756,265.581,395.28,240.887Z",
    transform: "translate(47.383 43.7)",
    fill: "#7ba859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M460.56,378.7S430.72,300.31,410.537,261.9",
    transform: "translate(52.307 50.483)",
    fill: "none",
    stroke: "#3d5539",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M358.653,258.739S424.564,285.6,454.516,358.85s24.056,88.91,24.056,88.91-62.323-48.09-85.809-86.673S367.041,281.648,358.653,258.739Z",
    transform: "translate(35.56 49.462)",
    fill: "#3d5539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M447.148,391.328s-44.694-80.344-73.388-112.261",
    transform: "translate(40.436 56.024)",
    fill: "none",
    stroke: "#7ba859",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M484.837,441.475a43.913,43.913,0,0,0-67.462-54.6,29.472,29.472,0,0,0-57.418-.258,38.483,38.483,0,0,0-56.379,34.07c0,.808.033,1.607.082,2.4a29.819,29.819,0,0,0-3.032-.155,29.475,29.475,0,0,0-27.362,18.542Z",
    transform: "translate(7.998 83.418)",
    fill: "#3d5539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M313.975,320.566s45.378-16.925,109.781,33.256S503.4,455.1,503.4,455.1s-51.371-9.051-103.879-52.419S351.18,339.924,313.975,320.566Z",
    transform: "translate(21.138 68.533)",
    fill: "#7ba859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M451.951,415.342s-37.762-46.193-109.9-87.692",
    transform: "translate(30.202 71.706)",
    fill: "none",
    stroke: "#3d5539",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M474.624,357.178,492.6,312.723,474.624,287.28l-19.709,52.386Z",
    transform: "translate(66.632 58.675)",
    fill: "#cc545a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M531.3,250.5s30.2,3.914,47.811,19.851,20.409,53.962,29.357,72.974,22.367,34.109,23.486,44.734-8.568,16.216-8.568,16.216H519.827s-12.016-7.828-12.016-16.216,3.355-11.184,0-20.13-40.928-71.464-40.928-71.464Z",
    transform: "translate(70.495 46.803)",
    fill: "#f06f76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M557.1,288.548s1.727,45.455,1.852,65.166-1.134,26.841,2.851,29.148S557.1,288.548,557.1,288.548Z",
    transform: "translate(99.618 59.084)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M541.284,324.759s4.9-11.6,5.385-22.927c.27-6.3-4.548-12.641-8.873-17.023l3.069-26.157L528.6,279.484h0l-55,8.711-3.008,2.146c4.926,7.316,26.632,39.567,34.911,52.172,9.367,14.26,6.431,32.293,4.753,37.746-.876,2.849-2.333,5.466-3.049,8.45,2.392,7.041,11.432,12.938,11.432,12.938H562.04C554.8,376.24,541.284,324.759,541.284,324.759Z",
    transform: "translate(71.69 49.434)",
    fill: "#cc545a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M579.138,381.093c-10.905-5.033-12.023-17.055-12.861-35.788s-8.257-56.757-8.257-56.757,2.665,45.574,3.224,56.757.839,29.637,0,35.229-6.976,9.716-6.976,9.716A14.647,14.647,0,0,0,555.741,392h39.434a19.9,19.9,0,0,0,7.205-8.049C596.254,385.539,587.7,385.045,579.138,381.093Z",
    transform: "translate(98.702 59.084)",
    fill: "#cc545a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M455.235,272s.556-20.813,1.255-25.146,3.076-16.776,5.872-16.216,2.837,4.343,2.978,8.816-.462,29.068-.462,29.068Z",
    transform: "translate(66.735 40.386)",
    fill: "#f7c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M455.751,254.066a3.564,3.564,0,0,0,1.675-.933s2.206-17,4.824-22.474c-.02,0-.034-.017-.054-.021-2.8-.56-5.173,11.883-5.872,16.216C456.117,248.136,455.923,250.865,455.751,254.066Z",
    transform: "translate(66.902 40.386)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M471.859,266.232s3.488-11.742,3.456-16.076-.312-10.486-3.456-9.786-3.426,11.463-5.244,14.958-6.151,11.883-6.99,14.258,4.333,27.121,4.333,27.121L440.754,359.2h34.562l6.539-49.767L495,299.756Z",
    transform: "translate(62.061 43.515)",
    fill: "#f7c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M463.4,288.361l-20.911,56.307,3.868.471,19.292-56.219-6.3-22.748h0C460.415,274.077,463.4,288.361,463.4,288.361Z",
    transform: "translate(62.621 51.862)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M485.614,287.98l-4.281-6.2-11.519-4.98a24.714,24.714,0,0,1,2.659,10.122v10.734Z",
    transform: "translate(71.442 55.291)",
    fill: "#e58c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M420.04,372.777h92.265L457.524,411.34Z",
    transform: "translate(55.375 86.272)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M485.244,400.7s-59.973-39.423-69.2-40.262-22.647,3.774-26.421,18.034-3.356,25.163,0,28.1,30.615,22.427,30.615,22.427h65.006Z",
    transform: "translate(44.693 82.258)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M531.5,385.677,501.92,323.118a5,5,0,0,0-4.524-2.865H390.027l30.933,65.424Z",
    transform: "translate(45.687 69.318)",
    fill: "#dae1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M525.107,385.677l-29.58-62.559A5,5,0,0,0,491,320.253H388.942a3.361,3.361,0,0,0-3.038,4.8l28.665,60.626Z",
    transform: "translate(44.251 69.318)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    d: "M0,0H156.252a0,0,0,0,1,0,0V12.861a0,0,0,0,1,0,0H5a5,5,0,0,1-5-5V0A0,0,0,0,1,0,0Z",
    transform: "translate(458.819 454.995)",
    fill: "#dae1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M537.295,327.059s16.645-2.754,23.281,13.442.763,31.853-5.388,37.723-24.6,0-24.6,0Z",
    transform: "translate(91.057 71.458)",
    fill: "#f38c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M519.832,246.262l13,6.742s-3.823,16.5-8.388,26.734-6.919,15.61-6.919,15.61l-14.26-8.233Z",
    transform: "translate(82.239 45.435)",
    fill: "#f38c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M484.426,277.818s-1.188,4.918-8.737,10.253-12,2.765-12.728,2.345,6.438-15.044,6.438-17.77-22.228-.628-20.97-6.71,9.856-5.662,15.518-17.4,8.635-21.379,24.953-26.841,29.358,8.807,29.358,8.807,15.516,1.258,20.55,15.727,0,24.534,0,24.534Z",
    transform: "translate(64.522 37.101)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M484.213,224.524c11.354-3.775,24.5-1.344,31.33,4.639-3.749-3.411-14.794-11.888-27.986-7.472-16.318,5.462-19.292,15.1-24.953,26.841a26.947,26.947,0,0,1-10.066,11.282,20.066,20.066,0,0,0,10.008-7.976C468.277,242.751,472.048,228.571,484.213,224.524Z",
    transform: "translate(65.865 37.101)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M524.586,254.136c-3.635,2.8-10.516,6.769-10.516,6.769l-36.4,8.228a25.094,25.094,0,0,1-7.953,8.4,22.948,22.948,0,0,1-2.833,1.721,96.9,96.9,0,0,0,10.453,12.63c10.625,10.625,22.427,20.363,27.291,20.247s18.515-11.187,21.917-24.44,2.784-18.1,2.784-18.1,5.044-1.75,5.884-8.461S528.22,251.34,524.586,254.136Z",
    transform: "translate(70.495 47.643)",
    fill: "#f7c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M489.353,262.869l-13.765,3.111a19.061,19.061,0,0,1-2.262,3.27l12.273,5.127,8.947,15.051s-.839,5.312.839,7.409,2.958,1.183,4.275,3.6-.022,8.363,8.057,4.06,13.81-20.237,13.81-20.237Z",
    transform: "translate(72.575 50.795)",
    fill: "#e58c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M532.532,305.9s-5.87-47.53-6.71-51.164-21.248-30.756-22.367-31.175-4.613,3.356-2.516,8.109,12.3,20.411,12.162,21.808-2.828-.851-4.753-3.076c-1.431-1.653-15.424-14.441-17.4-15.761-3.775-2.517-10.695-8.562-11.533-7.585s-2.935,5.732,3.075,12.023,22.964,21.528,22.964,21.528l-.737,1.4-33.69-17.335s-3.076,4.054,2.516,9.646,23.486,16.916,23.486,16.916-2.377,3.635-7.828,1.817-19.153-7.828-20.83-7.13-1.677,5.872,3.774,10.065,21.207,13.29,21.207,13.29,7.871,16.766,10.807,21.17a45.8,45.8,0,0,0,6.081,7.339s18.383,53.681,22.3,68.78,11.609,29.525,26.215,27.973,15.445-28.392,10.412-39.3S532.532,305.9,532.532,305.9Z",
    transform: "translate(70.657 38.097)",
    fill: "#f7c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M466.286,269.533l.9-3.3s3.487-11.742,3.456-16.076-.312-10.486-3.456-9.786-3.426,11.463-5.244,14.958c-1.667,3.206-5.446,10.521-6.707,13.543l11.051.661Z",
    transform: "translate(66.735 43.515)",
    fill: "#f7c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M637.819,367.575s9.306,28.518,8.658,41.939-5.492,31.873-21.9,31.873H565.584l-39.422-17.893s-29.088,14.539-44.181,17.893-53.117,0-53.117,0l-6.711-22.927s13.421-1.677,40.262-21.808,42.5-29.637,56.477-31.874S637.819,367.575,637.819,367.575Z",
    transform: "translate(56.057 83.506)",
    fill: "#545172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M442.119,429.21H384.243l-2.427-7.183a13.7,13.7,0,0,1,8.278-17.252h0a46.964,46.964,0,0,1,24.1-2.16l21.217,3.668Z",
    transform: "translate(42.802 95.682)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M479.39,268.865l-4.558,3.634a4.078,4.078,0,0,0-1.042,5.139l.962,1.769a5.649,5.649,0,0,0,7.566,2.318l8.081-4.195-3.73-5.087Z",
    transform: "translate(72.564 52.731)",
    fill: "#e58c7e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 7.013,
    cy: 10.834,
    rx: 7.013,
    ry: 10.834,
    transform: "translate(478.843 418.452) rotate(-29.044)",
    fill: "#dae1e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3277",
    "data-name": "Group 3277",
    transform: "translate(368.21 479.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 20.62,
    height: 24.265,
    rx: 4.941,
    transform: "translate(31.384 12.455)",
    fill: "none",
    stroke: "#dae1e6",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    d: "M3.8,0H35.059a3.8,3.8,0,0,1,3.8,3.8V42.328a3.8,3.8,0,0,1-3.8,3.8H3.8a3.8,3.8,0,0,1-3.8-3.8V3.8A3.8,3.8,0,0,1,3.8,0Z",
    fill: "#e9edf0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M561.912,276.761c9.491,14.518,16.561,34.99,16.581,35.042-4.371-16.272-9.6-33.251-19.949-42.612-8.055-7.287-18.733-12.055-27.96-15.089h0S552.409,262.223,561.912,276.761Z",
    transform: "translate(91.057 47.965)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M521.847,244.071c-.034-.1-.057-.2-.093-.3-5.033-14.469-20.55-15.727-20.55-15.727A62.621,62.621,0,0,1,521.847,244.071Z",
    transform: "translate(81.574 39.554)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M521.831,306.989c.886,2.575,32.595,59.045,39.844,71.94a24.517,24.517,0,0,0-1.319-3.7c-5.032-10.9-36.627-69.339-36.627-69.339s-5.87-47.53-6.711-51.165-21.248-30.755-22.367-31.174c0,0,18.093,26.3,19.991,31.367S520.831,304.08,521.831,306.989Z",
    transform: "translate(79.459 38.104)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M575.447,325.222c-2.4-5.1-4.36-11.585-6.282-18.634h0a96.34,96.34,0,0,0,12.475,35.482c8.154,13.679,14.522,23.323,17.292,31.043a15.714,15.714,0,0,0,0-3.156C597.814,359.333,584.395,344.235,575.447,325.222Z",
    transform: "translate(103.511 64.907)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M505.4,249.564c-1.431-1.653-15.424-14.441-17.4-15.761-3.743-2.5-10.572-8.453-11.5-7.6,3.164,2.622,12.1,10,15.638,12.686,3.747,2.841,13.015,11.895,15.735,13.113A21.681,21.681,0,0,1,505.4,249.564Z",
    transform: "translate(73.599 38.934)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M470.326,239.511a4.97,4.97,0,0,0-.787,2.161l34.477,15.174Z",
    transform: "translate(71.353 43.255)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M494.52,262.741h0a7.574,7.574,0,0,1-5.43-.022c-5.453-1.818-19.153-7.828-20.83-7.13a1.261,1.261,0,0,0-.549.474c2.81,1.016,8.117,2.945,13.176,4.824C488.227,263.613,493.578,264.8,494.52,262.741Z",
    transform: "translate(70.763 48.427)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M475.787,300.2h0c11.326,19.135,27.034,46.053,29.149,51.693a21.828,21.828,0,0,1,1.433,6.025h0s1.164-7.334-6.594-22.42S475.787,300.2,475.787,300.2Z",
    transform: "translate(73.369 62.844)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M463.685,307.065c-.243-.467-.487-.934-.738-1.4-23.882-43.992-67.667-64.782-67.667-64.782S435.054,265.705,463.685,307.065Z",
    transform: "translate(47.383 43.7)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M432.089,319.016c-32.082-43.418-73.436-60.277-73.436-60.277s30.306,19.88,41.5,29.736C411.2,298.2,431.561,318.489,432.089,319.016Z",
    transform: "translate(35.56 49.462)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M363.419,326.226c26.9,9.085,52.574,26.361,58.43,30.433-1.181-.947-2.345-1.9-3.561-2.843-37.135-28.935-67.942-35.558-87.374-35.979A223.079,223.079,0,0,1,363.419,326.226Z",
    transform: "translate(26.606 68.539)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M588.6,352.589c.065-.091,12.363-18.629,30.756-42.739,11.5-15.068,30.494-31.627,43.18-42.741C641.189,280.657,608.137,307.536,588.6,352.589Z",
    transform: "translate(109.785 52.164)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M659.114,318.116A333.236,333.236,0,0,1,697.5,292.724c-17.743,6.431-40.069,19.413-63.842,45.184a301.593,301.593,0,0,0-24.831,30.656C610.766,366.131,633.686,337.623,659.114,318.116Z",
    transform: "translate(116.314 60.432)",
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M546.914,430.668s6.99-8.2,3.635-18.547-22.088-12.3-30.2-7.828-8.388,6.5-23.765,12.059-27.679,10.309-35.229,18.7-6.43,15.937-2.8,21.249,33.879,4.474,45.038,0,15.354-12.3,25.419-17.055S542.161,435.794,546.914,430.668Z",
    transform: "translate(66.899 95.717)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    x2: 622,
    transform: "translate(248.489 524.893)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 5.073
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIllustration);
export default __webpack_public_path__ + "static/media/empty_illustration.2e2c9864cc15daa4054bd3e6ed4ccc9b.svg";
export { ForwardRef as ReactComponent };